const DEFAULT_VALUES = {
  fineAmount: 0,
  licencePoints: 0,
  drivingBanPeriod: 0,
};

const calculate = (data) => {
  if (data.DANGER_TO_PEOPLE == null || data.DAMAGE == null) {
    return DEFAULT_VALUES;
  }

  if (data.DANGER_TO_PEOPLE === "YES") {
    return {
      fineAmount: 150,
      licencePoints: 2,
      drivingBanPeriod: 1,
    };
  }

  if (data.DAMAGE === "YES") {
    return {
      fineAmount: 150,
      licencePoints: 2,
      drivingBanPeriod: 1,
    };
  }

  if (data.DAMAGE === "YES" && data.DANGER_TO_PEOPLE === "YES") {
    return {
      fineAmount: 200,
      licencePoints: 2,
      drivingBanPeriod: 1,
    };
  }

  return {
    licencePoints: 1,
    fineAmount: 100,
  };
};

export default calculate;
